import { memo, type ReactNode } from "react";
import Box from "@mui/material/Box";
import ToggleButtonGroup, {
  type ToggleButtonGroupProps,
} from "@mui/material/ToggleButtonGroup";

import {
  patientFinderToggleGroupSx,
  patientFinderToggleWrapperSx,
} from "./patientFinderToggleStyles";

export interface CommunicationsSegmentedFilterControlProps
  extends Pick<
    ToggleButtonGroupProps,
    "exclusive" | "value" | "onChange" | "aria-label" | "disabled"
  > {
  children: ReactNode;
}

/**
 * Grupo de toggles segmentado para filtros do modal de pacientes (layout de formulário).
 */
const CommunicationsSegmentedFilterControl = memo(
  ({
    exclusive = true,
    value,
    onChange,
    "aria-label": ariaLabel,
    disabled,
    children,
  }: CommunicationsSegmentedFilterControlProps) => {
    return (
      <Box sx={patientFinderToggleWrapperSx}>
        <ToggleButtonGroup
          exclusive={exclusive}
          value={value}
          onChange={onChange}
          aria-label={ariaLabel}
          disabled={disabled}
          sx={patientFinderToggleGroupSx}
        >
          {children}
        </ToggleButtonGroup>
      </Box>
    );
  },
);

CommunicationsSegmentedFilterControl.displayName =
  "CommunicationsSegmentedFilterControl";

export default CommunicationsSegmentedFilterControl;
